module.exports = __webpack_public_path__ + "static/media/desktop_instagram_display.cf0dddd6.png";